(function () {
    'use strict';

    angular.module("imApp").factory("acCustTransService", ['$ihttp', function ($ihttp) {
        var service = {
            getAcCustTrans: function (parms) {
                return $ihttp.post({
                    method: 2831,
                    parameters: parms || {}
                });
            },
            removeMatchingSelected: function (mergeObj) {
                return $ihttp.post({
                    method: 2833,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();